(function() {
    var SET_SUFFIXES = ['PM-Set', 'MS-Set', 'CS-Set', 'HP-Set', 'HC-Set', 'BD-Set'];
    var FINISH_SUFFIXES = [
        'GldPolly',
        'FLowerBR',
        'FLowerJQ',
        'Yarn Jaquard',
        'Waffle',
        'FruitTowel',
        'KitchenT',
        'POPCRN',
    ];

    var PALETTE = [{
            name: 'Aquafier Mist',
            hex: ['#B8D8D8'],
            aliases: ['aquafier mist', 'aquafier-mist', 'aquafier', 'aquifer', 'aquafr']
        },
        {
            name: 'Ivory Dune',
            hex: ['#E8DDC5'],
            aliases: ['ivory dune', 'ivory-dune']
        },
        {
            name: 'Beige',
            hex: ['#D8C3A5'],
            aliases: ['beige', 'cappuccino', 'cappicino', 'sand dune']
        },
        {
            name: 'Blueberry',
            hex: ['#3F5F9A'],
            aliases: ['blueberry', 'nvyb', 'cobalt', 'cob']
        },
        {
            name: 'Blush Kanchan',
            hex: ['#D98FA5'],
            aliases: ['blush kanchan']
        },
        {
            name: 'Blush',
            hex: ['#E8A6B8'],
            aliases: ['blush', 'lilac']
        },
        {
            name: 'Brown',
            hex: ['#795548'],
            aliases: ['brown', 'choc', 'chocolate', 'choclate']
        },
        {
            name: 'Charcoal Kanchan',
            hex: ['#454545'],
            aliases: ['charcoal kanchan', 'charcl']
        },
        {
            name: 'Charcoal',
            hex: ['#36454F'],
            aliases: ['charcoal']
        },
        {
            name: 'Cloud',
            hex: ['#E6E6E1'],
            aliases: ['cloud']
        },
        {
            name: 'Coral & Cloud',
            hex: ['#FF7F6A', '#E6E6E1'],
            aliases: ['coral & cloud', 'coral/cloud', 'coral/white']
        },
        {
            name: 'Coral & Fawn',
            hex: ['#FF7F6A', '#C8A27A'],
            aliases: ['coral & fawn', 'coral/fawn', 'coral/tan']
        },
        {
            name: 'Coral & Mist',
            hex: ['#FF7F6A', '#B8D8D8'],
            aliases: ['coral & mist', 'coral/mist', 'coral/sea green']
        },
        {
            name: 'Coral & Ocean',
            hex: ['#FF7F6A', '#3D8CA8'],
            aliases: ['coral & ocean', 'coral/ocean', 'coral/navy']
        },
        {
            name: 'Coral',
            hex: ['#FF7F6A'],
            aliases: ['coral']
        },
        {
            name: 'Dawn & Turq',
            hex: ['#F3C6A8', '#40C4C4'],
            aliases: ['dawn & turq', 'dawn/turq', 'baby pink/turquoise']
        },
        {
            name: 'Deep Teal',
            hex: ['#006D6F'],
            aliases: ['deep teal', 'sgreen']
        },
        {
            name: 'Emerald Set',
            hex: ['#009B77'],
            aliases: ['emerald set']
        },
        {
            name: 'Emerald',
            hex: ['#009B77'],
            aliases: ['emerald', 'green flower']
        },
        {
            name: 'Erget Bloom',
            hex: ['#A7BFAF'],
            aliases: ['erget bloom', 'erget-bloom']
        },
        {
            name: 'Erget',
            hex: ['#DED7CA'],
            aliases: ['erget']
        },
        {
            name: 'Fawn',
            hex: ['#C8A27A'],
            aliases: ['fawn']
        },
        {
            name: 'Flint',
            hex: ['#6F7678'],
            aliases: ['flint']
        },
        {
            name: 'Graphite Spa',
            hex: ['#4B5558'],
            aliases: ['graphite spa', 'graphite']
        },
        {
            name: 'Iris & Flint',
            hex: ['#6F5AA8', '#6F7678'],
            aliases: ['iris & flint', 'iris blue/charcoal', 'irise blue/charcoal']
        },
        {
            name: 'Iris & Paradise',
            hex: ['#6F5AA8', '#5BB5A8'],
            aliases: ['iris & paradise', 'iris blue/paradise']
        },
        {
            name: 'Iris & Tango',
            hex: ['#6F5AA8', '#E76F51'],
            aliases: ['iris & tango', 'iris blue/spanish']
        },
        {
            name: 'Jamun',
            hex: ['#5B2149'],
            aliases: ['jamun', 'prpl']
        },
        {
            name: 'Juniperberry',
            hex: ['#496B52'],
            aliases: ['juniperberry']
        },
        {
            name: 'Lemon Fruit Orange',
            hex: ['#F28C28'],
            aliases: ['lemon fruit orange', 'lorange', 'dorange', 'tangerine']
        },
        {
            name: 'Lemon Fruit Yellow',
            hex: ['#F4D03F'],
            aliases: ['lemon fruit yellow', 'lyellow', 'lemon zest']
        },
        {
            name: 'Merlot',
            hex: ['#722F37'],
            aliases: ['merlot', 'wine', 'suroor']
        },
        {
            name: 'Mist',
            hex: ['#B7C9C9'],
            aliases: ['mist']
        },
        {
            name: 'Mocha',
            hex: ['#8B6F5A'],
            aliases: ['mocha', 'cocoa']
        },
        {
            name: 'Mulberry',
            hex: ['#7B2D5F'],
            aliases: ['mulberry', 'mullberry']
        },
        {
            name: 'Ocean',
            hex: ['#3D8CA8'],
            aliases: ['ocean', 'navy blue']
        },
        {
            name: 'Paradise & Flint',
            hex: ['#5BB5A8', '#6F7678'],
            aliases: ['paradise & flint', 'paradise/flint']
        },
        {
            name: 'Paradise',
            hex: ['#5BB5A8'],
            aliases: ['paradise']
        },
        {
            name: 'Peacock Groove',
            hex: ['#006D77'],
            aliases: ['peacock groove']
        },
        {
            name: 'Pearl',
            hex: ['#E8E5D8'],
            aliases: ['pearl']
        },
        {
            name: 'Petunia Grace',
            hex: ['#9B6AA5'],
            aliases: ['petunia grace']
        },
        {
            name: 'Petunia',
            hex: ['#A8559A'],
            aliases: ['petunia', 'putinia', 'petnuia']
        },
        {
            name: 'Rose Gold',
            hex: ['#B76E79'],
            aliases: ['rose gold', 'rose']
        },
        {
            name: 'Ruby',
            hex: ['#C21833'],
            aliases: ['ruby']
        },
        {
            name: 'Sage',
            hex: ['#9CAF88'],
            aliases: ['sage', 'ssage']
        },
        {
            name: 'Sandstone Kanchan',
            hex: ['#C7A77A'],
            aliases: ['sandstone kanchan', 'sandstone', 'ash']
        },
        {
            name: 'Scarlet Kanchan',
            hex: ['#B91C1C'],
            aliases: ['scarlet kanchan']
        },
        {
            name: 'Scarlet',
            hex: ['#D62828'],
            aliases: ['scarlet', 'dred']
        },
        {
            name: 'Sepia & Olive',
            hex: ['#704214', '#708238'],
            aliases: ['sepia & olive', 'sepia brown/olive']
        },
        {
            name: 'Sepia & Dawn',
            hex: ['#704214', '#F3C6A8'],
            aliases: ['sepia & dawn', 'sepia/dawn']
        },
        {
            name: 'Sepia',
            hex: ['#704214'],
            aliases: ['sepia', 'sepia brown']
        },
        {
            name: 'Silver Ash',
            hex: ['#A7A9AC'],
            aliases: ['silver ash', 'silver-ash', 'frgtirn']
        },
        {
            name: 'Silverberry',
            hex: ['#AAB7B8'],
            aliases: ['silverberry']
        },
        {
            name: 'Slate & Ocean',
            hex: ['#667784', '#3D8CA8'],
            aliases: ['slate & ocean', 'slate/ocean']
        },
        {
            name: 'Slate',
            hex: ['#667784'],
            aliases: ['slate']
        },
        {
            name: 'Strawberry Fruit',
            hex: ['#E94B5F'],
            aliases: ['strawberry fruit', 'strawberry', 'berry pop']
        },
        {
            name: 'Tango & Flint',
            hex: ['#E76F51', '#6F7678'],
            aliases: ['tango & flint', 'tango/flint']
        },
        {
            name: 'Tango',
            hex: ['#E76F51'],
            aliases: ['tango', 'spanish red']
        },
        {
            name: 'Tanzanite',
            hex: ['#4169A1'],
            aliases: ['tanzanite']
        },
        {
            name: 'Taupe Kanchan',
            hex: ['#8B8178'],
            aliases: ['taupe kanchan']
        },
        {
            name: 'Taupe Resham',
            hex: ['#A89F91'],
            aliases: ['taupe resham', 'taupe']
        },
        {
            name: 'The Berry Trio',
            hex: ['#8E3A59'],
            aliases: ['the berry trio', 'berry trio']
        },
        {
            name: 'Turq & Olive',
            hex: ['#40C4C4', '#708238'],
            aliases: ['turq & olive', 'turq/olive']
        },
        {
            name: 'Turq',
            hex: ['#40C4C4'],
            aliases: ['turq', 'turquoise']
        },
        {
            name: 'Violet Veil',
            hex: ['#9B8BB5'],
            aliases: ['violet veil', 'violet-veil', 'violet', 'voilet']
        },
        {
            name: 'Olive',
            hex: ['#708238'],
            aliases: ['olive', 'olive green']
        },
        {
            name: 'Dawn',
            hex: ['#F3C6A8'],
            aliases: ['dawn', 'baby pink']
        },
        {
            name: 'Iris',
            hex: ['#6F5AA8'],
            aliases: ['iris', 'irise', 'iris blue', 'irise blue']
        },
        {
            name: 'White',
            hex: ['#E6E6E1'],
            aliases: ['white']
        },
        {
            name: 'Tan',
            hex: ['#C8A27A'],
            aliases: ['tan']
        },
    ];

    PALETTE.sort(function(a, b) {
        return b.name.length - a.name.length;
    });

    function normalizeSku(sku) {
        return String(sku || '')
            .trim()
            .replace(/\s*-\s*/g, '-')
            .replace(/\s+/g, ' ');
    }

    function skuFamily(sku) {
        var s = normalizeSku(sku);
        if (!s) return '';
        var match = s.match(/^(CL-[A-Z]{2}-(?:\d+[A-Z0-9]+)(?:-\d+[A-Z0-9]+)?)/i);
        if (!match) return s;
        var prefix = match[1];
        var rest = s.slice(prefix.length).replace(/^-/, '').toLowerCase();
        var i;
        for (i = 0; i < SET_SUFFIXES.length; i += 1) {
            if (rest.indexOf(SET_SUFFIXES[i].toLowerCase()) !== -1 && rest.slice(-SET_SUFFIXES[i].length).toLowerCase() === SET_SUFFIXES[i].toLowerCase()) {
                return prefix + '-' + SET_SUFFIXES[i];
            }
        }
        for (i = 0; i < FINISH_SUFFIXES.length; i += 1) {
            if (rest.slice(-FINISH_SUFFIXES[i].length).toLowerCase() === FINISH_SUFFIXES[i].toLowerCase()) {
                return prefix + '-' + FINISH_SUFFIXES[i];
            }
        }
        return prefix;
    }

    function skuColor(sku) {
        var s = normalizeSku(sku);
        var prefixMatch = s.match(/^(CL-[A-Z]{2}-(?:\d+[A-Z0-9]+)(?:-\d+[A-Z0-9]+)?)-?/i);
        var color = prefixMatch ? s.slice(prefixMatch[1].length).replace(/^-/, '') : s;
        var i;
        var suffix;
        for (i = 0; i < SET_SUFFIXES.length; i += 1) {
            suffix = SET_SUFFIXES[i];
            if (color.toLowerCase().slice(-suffix.length) === suffix.toLowerCase()) {
                color = color.slice(0, color.length - suffix.length).replace(/-$/, '');
            }
        }
        for (i = 0; i < FINISH_SUFFIXES.length; i += 1) {
            suffix = FINISH_SUFFIXES[i];
            if (color.toLowerCase().slice(-suffix.length) === suffix.toLowerCase()) {
                color = color.slice(0, color.length - suffix.length).replace(/-$/, '');
            }
        }
        return color.replace(/-/g, ' ').trim();
    }

    function normalizeKey(value) {
        return String(value || '')
            .toLowerCase()
            .replace(/_/g, '-')
            .replace(/\s*\/\s*/g, '/')
            .replace(/\s*&\s*/g, ' & ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function hasToken(haystack, needle) {
        if (!needle) return false;
        if (haystack === needle) return true;
        return (' ' + haystack + ' ').indexOf(' ' + needle + ' ') !== -1 || haystack.indexOf(needle) !== -1;
    }

    function matchSingleColor(text) {
        var haystack = normalizeKey(text);
        var best = null;
        var bestLen = 0;
        var i;
        var j;
        var names;
        var name;
        for (i = 0; i < PALETTE.length; i += 1) {
            if (!PALETTE[i].hex || PALETTE[i].hex.length !== 1) continue;
            names = [PALETTE[i].name].concat(PALETTE[i].aliases || []);
            for (j = 0; j < names.length; j += 1) {
                name = normalizeKey(names[j]);
                if (hasToken(haystack, name) && name.length > bestLen) {
                    best = PALETTE[i];
                    bestLen = name.length;
                }
            }
        }
        return best;
    }

    function splitDualParts(item) {
        var sources = [item.sku, skuColor(item.sku), item.color, item.title];
        var i;
        var text;
        var parts;
        var right;
        for (i = 0; i < sources.length; i += 1) {
            text = String(sources[i] || '');
            if (text.indexOf('/') === -1) continue;
            parts = text.split('/');
            if (parts.length === 2 && parts[0].trim() && parts[1].trim()) {
                return [parts[0].trim(), parts[1].trim()];
            }
        }
        for (i = 0; i < sources.length; i += 1) {
            text = String(sources[i] || '');
            if (text.toLowerCase().indexOf(' & ') === -1) continue;
            parts = text.split(/ & /i);
            if (parts.length < 2) continue;
            right = parts[1]
                .replace(/\s*[-–].*$/, '')
                .replace(/\s+\d+\s+.*$/i, '')
                .trim();
            if (parts[0].trim() && right) return [parts[0].trim(), right];
        }
        return null;
    }

    function matchNamedPalette(item) {
        var haystack = normalizeKey([item.color, item.title, skuColor(item.sku), item.sku].join(' '));
        var best = null;
        var bestLen = 0;
        var i;
        var j;
        var names;
        var name;
        for (i = 0; i < PALETTE.length; i += 1) {
            names = [PALETTE[i].name].concat(PALETTE[i].aliases || []);
            for (j = 0; j < names.length; j += 1) {
                name = normalizeKey(names[j]);
                if (hasToken(haystack, name) && name.length > bestLen) {
                    best = PALETTE[i];
                    bestLen = name.length;
                }
            }
        }
        return best;
    }

    function matchPalette(item) {
        var named = matchNamedPalette(item);
        if (named && named.hex && named.hex.length === 2) return named;
        var dual = splitDualParts(item);
        var left;
        var right;
        if (dual) {
            left = matchSingleColor(dual[0]);
            right = matchSingleColor(dual[1]);
            if (left && right) {
                return {
                    name: left.name + ' & ' + right.name,
                    hex: [left.hex[0], right.hex[0]],
                };
            }
        }
        return named;
    }

    function swatchBackground(entry) {
        var hexes = (entry && entry.hex) || ['#C8C8C8'];
        if (hexes.length === 1) return 'background-color:' + hexes[0];
        return 'background:linear-gradient(135deg, ' + hexes[0] + ' 0 50%, ' + hexes[1] + ' 50% 100%)';
    }

    function colorName(item) {
        var matched = matchPalette(item);
        if (matched) return matched.name;
        if (item.color && item.color.toLowerCase() !== 'default title') return item.color;
        return skuColor(item.sku) || item.title || '';
    }

    function nodeItem(el) {
        return {
            handle: el.getAttribute('data-handle') || '',
            url: el.getAttribute('data-url') || '',
            title: el.getAttribute('data-title') || '',
            sku: el.getAttribute('data-sku') || '',
            image: el.getAttribute('data-image-large') || el.getAttribute('data-image') || '',
            color: el.getAttribute('data-color') || '',
        };
    }

    function uniqueColors(items) {
        var out = [];
        var seen = {};
        var i;
        var name;
        for (i = 0; i < items.length; i += 1) {
            name = colorName(items[i]).toLowerCase();
            if (!name || seen[name]) continue;
            seen[name] = true;
            out.push(items[i]);
        }
        return out;
    }

    function paint(nodes, extraCatalog) {
        var catalog = [];
        var groups = {};
        var i;
        var key;
        var item;
        for (i = 0; i < nodes.length; i += 1) catalog.push(nodeItem(nodes[i]));
        if (extraCatalog && extraCatalog.length) catalog = catalog.concat(extraCatalog);

        for (i = 0; i < catalog.length; i += 1) {
            key = skuFamily(catalog[i].sku);
            if (!key) continue;
            if (!groups[key]) groups[key] = [];
            groups[key].push(catalog[i]);
        }

        for (i = 0; i < nodes.length; i += 1) {
            item = nodeItem(nodes[i]);
            key = skuFamily(item.sku);
            var siblings = uniqueColors(groups[key] || []);
            if (siblings.length < 2) continue;
            if (siblings.length < nodes[i].querySelectorAll('.card-swatch').length) continue;
            var html = '';
            var s;
            var matched;
            var name;
            var active;
            for (s = 0; s < siblings.length; s += 1) {
                matched = matchPalette(siblings[s]);
                name = (matched && matched.name) || colorName(siblings[s]);
                active = siblings[s].handle === item.handle ? ' is-active' : '';
                html +=
                    '<a href="' +
                    siblings[s].url +
                    '" class="card-swatch' +
                    active +
                    '" title="' +
                    name +
                    '" style="' +
                    swatchBackground(matched) +
                    '"><span class="visually-hidden">' +
                    name +
                    '</span></a>';
            }
            nodes[i].innerHTML = html;
        }
    }

    function nodes() {
        return Array.prototype.slice.call(document.querySelectorAll('[data-color-swatches]'));
    }

    function productToItem(product) {
        var variant = (product.variants && product.variants[0]) || {};
        var option;
        var color = '';
        var o;
        if (product.options) {
            for (o = 0; o < product.options.length; o += 1) {
                option = product.options[o];
                if (/colou?r/i.test(option.name || '') && option.values && option.values[0] && option.values[0] !== 'Default Title') {
                    color = option.values[0];
                }
            }
        }
        return {
            handle: product.handle,
            url: '/products/' + product.handle,
            title: product.title,
            sku: variant.sku || '',
            image: (product.images && product.images[0] && product.images[0].src) || '',
            color: color,
        };
    }

    function fetchCatalog(done) {
        var req = new XMLHttpRequest();
        req.open('GET', '/products.json?limit=250&page=1', true);
        req.onreadystatechange = function() {
            if (req.readyState !== 4) return;
            try {
                var data = JSON.parse(req.responseText);
                var products = data.products || [];
                var items = [];
                var i;
                for (i = 0; i < products.length; i += 1) items.push(productToItem(products[i]));
                done(items);
            } catch (err) {
                done([]);
            }
        };
        req.send();
    }

    function pageCatalog() {
        var el = document.getElementById('casalino-swatch-page');
        if (!el) return [];
        try {
            return JSON.parse(el.textContent || '[]');
        } catch (err) {
            return [];
        }
    }

    function collectionHandle() {
        var grid = document.getElementById('product-grid');
        if (grid && grid.getAttribute('data-collection-handle')) {
            return grid.getAttribute('data-collection-handle');
        }
        var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
        return match ? match[1] : '';
    }

    function hideDuplicateColorCards(catalog) {
        var grouped = {};
        var i;
        var key;
        var handle;
        var firstByFamily = {};
        var unique;
        var source = catalog && catalog.length ? catalog : [];
        for (i = 0; i < source.length; i += 1) {
            key = skuFamily(source[i].sku);
            if (!key) continue;
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(source[i]);
        }
        for (key in grouped) {
            if (!Object.prototype.hasOwnProperty.call(grouped, key)) continue;
            unique = uniqueColors(grouped[key]);
            if (unique.length > 1) firstByFamily[key] = unique[0].handle;
        }

        var list = nodes();
        if (!source.length) {
            var seen = {};
            for (i = 0; i < list.length; i += 1) {
                key = skuFamily(list[i].getAttribute('data-sku'));
                handle = list[i].getAttribute('data-handle');
                var card = list[i].closest('.grid__item');
                if (!card || !key) continue;
                if (seen[key]) {
                    card.classList.add('card-color-duplicate');
                } else {
                    seen[key] = handle;
                    card.classList.remove('card-color-duplicate');
                }
            }
            return;
        }

        for (i = 0; i < list.length; i += 1) {
            key = skuFamily(list[i].getAttribute('data-sku'));
            handle = list[i].getAttribute('data-handle');
            var itemCard = list[i].closest('.grid__item');
            if (!itemCard) continue;
            if (firstByFamily[key] && handle !== firstByFamily[key]) {
                itemCard.classList.add('card-color-duplicate');
            } else {
                itemCard.classList.remove('card-color-duplicate');
            }
        }
    }

    function fetchCollectionCatalog(done) {
        var handle = collectionHandle();
        if (!handle) {
            done([]);
            return;
        }
        var req = new XMLHttpRequest();
        req.open('GET', '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', true);
        req.onreadystatechange = function() {
            if (req.readyState !== 4) return;
            try {
                var data = JSON.parse(req.responseText);
                var products = data.products || [];
                var items = [];
                var i;
                for (i = 0; i < products.length; i += 1) items.push(productToItem(products[i]));
                done(items);
            } catch (err) {
                done([]);
            }
        };
        req.send();
    }

    function queryParam(name) {
        var search = String(window.location.search || '').replace(/^\?/, '');
        if (!search) return '';
        var parts = search.split('&');
        var i;
        var pair;
        for (i = 0; i < parts.length; i += 1) {
            if (!parts[i]) continue;
            pair = parts[i].split('=');
            if (decodeURIComponent(pair[0]) === name) {
                return decodeURIComponent((pair[1] || '').replace(/\+/g, ' '));
            }
        }
        return '';
    }

    function groupedPageFromUrl() {
        var page = parseInt(queryParam('pg') || queryParam('p') || '1', 10);
        if (!page || page < 1) return 1;
        return page;
    }

    function groupedCardItems(grid) {
        var items = [];
        var i;
        var child;
        for (i = 0; i < grid.children.length; i += 1) {
            child = grid.children[i];
            if (child && child.classList && child.classList.contains('grid__item')) items.push(child);
        }
        return items;
    }

    function updateGroupedPagination(page, pageCount, baseUrl) {
        var nav = document.querySelector('[data-grouped-pagination]');
        if (!nav) return;
        var links = nav.querySelectorAll('a[data-page]');
        var i;
        var link;
        var linkPage;
        var prevWrap = nav.querySelector('.pagination-grouped__prev');
        var nextWrap = nav.querySelector('.pagination-grouped__next');
        var prevLink = prevWrap ? prevWrap.querySelector('a') : null;
        var nextLink = nextWrap ? nextWrap.querySelector('a') : null;
        for (i = 0; i < links.length; i += 1) {
            link = links[i];
            if (link.classList.contains('pagination__item-arrow')) continue;
            linkPage = parseInt(link.getAttribute('data-page'), 10);
            if (linkPage === page) {
                link.classList.add('pagination__item--current', 'light');
                link.setAttribute('aria-current', 'page');
            } else {
                link.classList.remove('pagination__item--current', 'light');
                link.removeAttribute('aria-current');
            }
        }
        if (prevWrap) {
            if (page > 1) prevWrap.removeAttribute('hidden');
            else prevWrap.setAttribute('hidden', '');
        }
        if (nextWrap) {
            if (page < pageCount) nextWrap.removeAttribute('hidden');
            else nextWrap.setAttribute('hidden', '');
        }
        if (prevLink) {
            prevLink.setAttribute('data-page', String(Math.max(1, page - 1)));
            prevLink.setAttribute('href', baseUrl + Math.max(1, page - 1));
        }
        if (nextLink) {
            nextLink.setAttribute('data-page', String(Math.min(pageCount, page + 1)));
            nextLink.setAttribute('href', baseUrl + Math.min(pageCount, page + 1));
        }
    }

    function applyGroupedPage() {
        var grid = document.getElementById('product-grid');
        if (!grid || grid.getAttribute('data-color-system') !== 'true') return;
        var perPage = parseInt(grid.getAttribute('data-per-page') || '16', 10) || 16;
        var items = groupedCardItems(grid);
        var pageCount = Math.max(1, Math.ceil(items.length / perPage));
        var page = groupedPageFromUrl();
        if (page > pageCount) page = pageCount;
        var start = (page - 1) * perPage;
        var end = start + perPage;
        var i;
        for (i = 0; i < items.length; i += 1) {
            if (i >= start && i < end) items[i].classList.remove('card-page-hidden');
            else items[i].classList.add('card-page-hidden');
        }
        var nav = document.querySelector('[data-grouped-pagination]');
        var baseUrl = nav ? nav.getAttribute('data-base-url') || '?pg=' : '?pg=';
        updateGroupedPagination(page, pageCount, baseUrl);
        grid.classList.add('is-paged');
    }

    function groupedPageUrl(page) {
        var nav = document.querySelector('[data-grouped-pagination]');
        var baseUrl = nav ? nav.getAttribute('data-base-url') || '' : '';
        if (baseUrl) return baseUrl + page;
        return window.location.pathname + '?pg=' + page;
    }

    function goGroupedPage(page, push) {
        var url = groupedPageUrl(page);
        if (push && window.history && window.history.pushState) {
            window.history.pushState({ searchParams: url.split('?')[1] || '' }, '', url);
            if (typeof FacetFiltersForm !== 'undefined') {
                FacetFiltersForm.searchParamsPrev = url.split('?')[1] || '';
            }
        }
        applyGroupedPage();
        var el = document.getElementById('ProductGridContainer');
        if (el && el.scrollIntoView) el.scrollIntoView({ block: 'start' });
    }

    function onGroupedPaginationClick(event) {
        var link = event.target;
        var nav;
        var page;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        while (link && link !== document && !(link.tagName === 'A' && link.classList && link.classList.contains('pagination__item'))) {
            link = link.parentNode;
        }
        if (!link || link === document) return;
        nav = link.closest ? link.closest('[data-grouped-pagination]') : null;
        if (!nav) return;
        page = parseInt(link.getAttribute('data-page') || '0', 10);
        if (!page) return;
        event.preventDefault();
        if (page === groupedPageFromUrl()) return;
        goGroupedPage(page, true);
    }

    function init() {
        var grid = document.getElementById('product-grid');
        if (!grid || grid.getAttribute('data-color-system') !== 'true') return;
        applyGroupedPage();
        if (groupedPageFromUrl() > 1) {
            var el = document.getElementById('ProductGridContainer');
            if (el && el.scrollIntoView) el.scrollIntoView({ block: 'start' });
        }
        var list = nodes();
        if (!list.length) return;
        paint(list, pageCatalog());
        fetchCollectionCatalog(function(collectionItems) {
            var extra = collectionItems.length ? collectionItems : pageCatalog();
            paint(nodes(), extra);
        });
        fetchCatalog(function(storeItems) {
            if (storeItems && storeItems.length) paint(nodes(), storeItems);
        });
    }

    window.casalinoApplyGroupedPage = applyGroupedPage;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('click', onGroupedPaginationClick);
    window.addEventListener('popstate', applyGroupedPage);
})();